import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { TBooleanInNumber } from 'src/types/main';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface ICardItem {
  name: string;
  value: TBooleanInNumber;
  onChange: (name: string | number, value: boolean | undefined) => void;
  disabled?: boolean;
}

interface IProps {
  wrapperClassName?: string;
  titleClassName?: string;
  itemClassName?: string;
  title: string;
  items?: ICardItem[];
  onExpand?: (expanded: boolean) => void;
}

const CardWithCheckboxes: React.FC<IProps> = observer((props: IProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const collapseGroup = () => {
    setCollapsed(!collapsed);
    if (props.onExpand !== undefined) {
      props.onExpand(collapsed);
    }
  };
  return (
    <div className={`card-with-checkboxes__wrapper ${props.wrapperClassName || ''}`}>
      <div
        className={`d-flex align-items-center justify-content-between card-with-checkboxes__header px-4 ${props.titleClassName || ''}`}
        onClick={collapseGroup}
      >
        {props.title}
        <Icon
          name={Icons.Chevron}
          size={24}
          color={theme.colors.dark}
          className={`card-with-checkboxes__header-chevron ${!collapsed ? 'expanded' : ''}`}
        />
      </div>
      {!collapsed && (
        <div className="card-with-checkboxes__content">
          {(props.items || []).map((item, index) => (
            <div
              key={`${item.name}_item_${index}`}
              className={`d-flex align-items-center justify-content-start card-with-checkboxes__content-item ${props.itemClassName || ''}`}
            >
              <Checkbox
                name={item.name}
                onClick={(name, value) => item.onChange(name, !value)}
                label={localeStore.t(item.name)}
                value={Number(item.value) === 1}
                className="card-with-checkboxes__checkbox"
                labelClassName="card-with-checkboxes__checkbox-label"
                disabled={item.disabled}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
});
export default CardWithCheckboxes;
